// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3hvTi","range":"MonthRangeSwitch_range__2uSZU","disabled":"MonthRangeSwitch_disabled__2sZHi"};